import { ChakraProvider } from "@chakra-ui/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";

import { theme } from "@assets/theme/theme";

import configureStore from "./store";
import App from "./containers/App/App";
import * as serviceWorker from "./serviceWorker";

import "@assets/fonts/stylesheet.css";
import "@assets/styles/index.scss";

const { store } = configureStore();

const container = document.getElementById("root");

const root = createRoot(container!);
root.render(
  <StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ChakraProvider value={theme}>
          <App />
        </ChakraProvider>
      </Provider>
    </BrowserRouter>
  </StrictMode>,
);

serviceWorker.unregister();

export { store };
